/* Interview Clozo — the account page: the web control centre (CONTRACT R12 GET /billing/summary and the actions it
   offers: R13 Start plan now, R14/R15 Switch to Yearly, R3 renew / trial checkout, R34 renew
   with the saved card, R38 pay overdue, R16 Keep my plan, R6 "Use another card or Link", R18 set a password, R20 the
   web entry of the cancellation flow, R33 celebrations).

   OWNER RULINGS THIS PAGE CARRIES
   - D11: plans renew automatically; nothing here pauses, skips or stops a renewal except the cancellation flow.
   - D12.1 / D12.5: [Cancel subscription] is the website's only cancellation entry; the click is recorded at once (R20)
     and the flow continues on its own page. No other control on this page cancels anything.
   - D12.9 / D13.10: no checkbox anywhere; every pay confirmation shows the server's terms beside its button and the
     sentence "By continuing, you agree to our Terms of Service and Refund Policy."
   - D12.13: celebrations for a purchase made here and for pending automatic ones ("Thanks for renewing").
   - D13.2 / D15.1: a kept plan whose payment failed shows the server's sentence and [Pay now] (R38); never a second plan.
   - D13.8: one-click Start plan now / Switch to Yearly (also to the other provider) / renew with the saved card, and
     "Use another card or Link" beside them.
   - D13.9: no Member / Founding Member badge, no "You save" figure.
   - D15.8: no "Finish cancelling" control.  D19.1: Start Free Trial only when R12 says this account can trial.
   Every server sentence (confirmText, termsText, buttonLabel, agreementText, payment.message, trial.meterText, error
   messages) is shown verbatim, as text. */
(function () {
  'use strict';
  var A = window.InterviewAuth;
  var UI = window.clozoBillingUI;
  if (!A || !UI) { document.documentElement.classList.remove('cb-wait'); return; }
  if (!A.requireAuth('/login.html')) return;   // the head guard normally did this before anything loaded

  var $ = function (id) { return document.getElementById(id); };
  var money = UI.money, day = UI.day, el = UI.el;

  var MSG = {
    network: 'We couldn’t reach our servers. Nothing has been charged. Check your connection and try again.',
    provider: 'We couldn’t reach our payment provider. Nothing has been charged. Please try again in a moment.',
    disclosure: 'The payment terms have been updated. Nothing has been charged — please review them before you continue.',
    generic: 'That did not go through. Nothing has been charged. Please try again.',
    unavailable: 'Some billing details are temporarily unavailable.',
    portal: 'Updating your payment method isn’t available right now. Please try again later.'
  };
  var PLAN_NAMES = { monthly: 'Monthly', yearly: 'Yearly' };
  var CACHE_KEY = 'clozo_summary_v1';

  var S = null;            // the latest R12 body
  var fresh = false;       // S came from the server during this page view (a cached paint keeps actions disabled)
  var catalog = null;      // GET /api/plans, fetched once when the choose-plan rows need prices
  var celebratedThisView = false;
  var hashDone = false;
  var ready = document.readyState !== 'loading';
  if (!ready) document.addEventListener('DOMContentLoaded', function () { ready = true; });

  function whenReady(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function whenVisible(fn) {
    if (document.visibilityState !== 'hidden') { fn(); return; }
    var on = function () { if (document.visibilityState === 'hidden') return; document.removeEventListener('visibilitychange', on); fn(); };
    document.addEventListener('visibilitychange', on);
  }
  function tzq() { var tz = UI.timeZone(); return tz ? '?timeZone=' + encodeURIComponent(tz) : ''; }
  function bounce() { A.clearSession(); location.replace('/login.html?next=' + encodeURIComponent(location.pathname + location.search + location.hash)); }
  function acts() { return (S && S.actions) || {}; }
  function st() { return String((S && S.status) || '').toLowerCase(); }
  function planID() { return (S && S.plan && S.plan.planID) || ''; }
  function planName(id) { return PLAN_NAMES[id || planID()] || (S && S.plan && S.plan.name) || ''; }
  function currency() { return (S && S.plan && S.plan.currency) || 'usd'; }
  function isPaidPlan() { return planID() === 'monthly' || planID() === 'yearly'; }
  function trialing() { return st() === 'trialing' && isPaidPlan(); }
  function entitled() { return isPaidPlan() && (st() === 'trialing' || st() === 'active' || st() === 'pastdue' || st() === 'incomplete' || !!(S && S.cancellation)); }
  function pmLabel() { return (S && S.paymentMethod && S.paymentMethod.label) || ''; }
  function stripePortal() { var u = acts().updatePaymentMethod; return !!(u && u.available && u.method === 'stripe_portal'); }
  function email() { return (S && S.account && S.account.email) || ((A.currentUser() || {}).email) || 'your email'; }
  function endMillis() { return (S && S.cancellation && S.cancellation.effectiveAtMillis) || (S && S.currentPeriodEndMillis) || null; }
  function track(action, result, code) {
    if (result) UI.track('account_action_result', { action: action, result: result, code: code || undefined });
    else UI.track('account_action_clicked', { action: action });
  }

  /* =====================================================================================================
     Identity, email and marketing (moved unchanged from the page's former inline script)
     ===================================================================================================== */
  var emailEl = $('ac-email'), nameEl = $('ac-name'), avatarEl = $('ac-avatar'), badgeEl = $('ac-plan-badge');
  var noticeEl = $('ac-notice'), emailValueEl = $('ac-email-value'), emailStateEl = $('ac-email-state');
  var emailOk = $('ac-email-ok'), emailErr = $('ac-email-err'), emailForm = $('ac-email-form');
  var emailInput = $('ac-email-input'), emailPw = $('ac-email-pw'), emailSave = $('ac-email-save');
  var emailToggle = $('ac-email-toggle'), resendBtn = $('ac-resend');
  var marketingEl = $('ac-marketing'), marketingErr = $('ac-marketing-error');
  var logoutBtn = $('ac-logout');

  A.initPasswordToggles();
  var currentUser = null;
  var lastVerification = null;

  function api(path, body) {   // the email panel's helper: throws {status, code} like auth.js
    return UI.api('POST', path, body || {}).then(function (r) {
      if (r.ok) return r.data || {};
      var err = new Error((r.data && (r.data.message || r.data.error)) || 'That did not work. Please try again.');
      err.status = r.status; err.code = r.data && r.data.code; err.network = r.network;
      throw err;
    });
  }
  function isNetworkError(err) { return !!(err && err.network); }
  function fieldError(id, msg) {
    var box = document.querySelector('[data-error-for="' + id + '"]');
    var input = $(id);
    if (box) box.textContent = msg || '';
    if (input) input.classList.toggle('invalid', !!msg);
  }
  function emailMessage(kind, html, addr) {   // addr fills a <strong data-email> slot (UI.email: no mid-word wrap)
    emailOk.hidden = true; emailErr.hidden = true;
    if (!html) return;
    var box = kind === 'ok' ? emailOk : emailErr;
    box.innerHTML = html; box.hidden = false;
    var slot = addr && box.querySelector('[data-email]');
    if (slot) UI.email(slot, addr);
  }
  function bounceIfSignedOut(err) {
    if (err && (err.status === 401 || err.code === 'session_invalid')) { bounce(); return true; }
    return false;
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function setIdentity(user) {
    if (!user) return;
    var identity = user.email || user.username || '';
    if (identity) UI.email(emailEl, identity);
    var sub = [];
    if (user.fullName) sub.push(user.fullName);
    if (user.username && user.email) sub.push('@' + user.username);
    nameEl.textContent = sub.join(' · ');
    var seed = (user.fullName || user.email || user.username || '?').trim();
    avatarEl.textContent = seed ? seed.charAt(0).toUpperCase() : '?';
    currentUser = user;
    renderEmail(user, lastVerification);
    var pwUser = $('ac-pw-user');
    if (pwUser && user.email) pwUser.value = user.email;
  }
  function renderEmail(user, verification) {
    if (!user) return;
    var state = (verification && verification.state) ||
      (!user.email ? 'missing' : (user.emailVerified === false ? 'unverified' : 'verified'));
    var delivery = (verification && verification.delivery) || '';
    var mailerOff = verification ? verification.mailerConfigured === false : false;
    if (user.email) UI.email(emailValueEl, user.email); else emailValueEl.textContent = 'None on this account';
    emailStateEl.textContent = state === 'verified' ? 'Confirmed' : state === 'unverified' ? 'Not confirmed yet' : 'Not set';
    resendBtn.style.display = state === 'unverified' ? '' : 'none';
    emailToggle.querySelector('.btn-label').textContent = user.email ? 'Change email address' : 'Add an email address';
    if (state === 'missing') {
      noticeEl.innerHTML = 'This account has no email address, so a forgotten password cannot be reset. ' +
        'Add one below and we will send it a confirmation link.';
      noticeEl.hidden = false;
      emailForm.style.display = '';
    } else if (state === 'unverified' && (delivery === 'failed' || delivery === 'skipped' || mailerOff)) {
      noticeEl.innerHTML = '<strong data-email></strong> is not confirmed, and our last attempt to email ' +
        'it did not go through. Try again below — your account itself is unaffected.';
      UI.email(noticeEl.querySelector('[data-email]'), user.email);
      noticeEl.hidden = false;
    } else if (state === 'unverified') {
      noticeEl.innerHTML = 'Confirm <strong data-email></strong> to keep password resets and receipts ' +
        'reaching you. Open the welcome email we sent you (the "Set your password / sign in" button), or resend a confirmation link below.';
      UI.email(noticeEl.querySelector('[data-email]'), user.email);
      noticeEl.hidden = false;
    } else {
      noticeEl.hidden = true;
    }
    if (typeof user.marketingOptIn === 'boolean') marketingEl.checked = user.marketingOptIn;
  }
  function adopt(data) {
    if (!data) return;
    if (data.verification) lastVerification = data.verification;
    if (data.user) {
      var session = A.getSession();
      if (session) { session.user = data.user; A.setSession(session); }
      setIdentity(data.user);
    } else {
      renderEmail(currentUser, lastVerification);
    }
  }

  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    emailMessage(); fieldError('ac-email-input', ''); fieldError('ac-email-pw', '');
    var value = emailInput.value.trim();
    var password = emailPw.value;
    var bad = false;
    if (!value) { fieldError('ac-email-input', 'Enter the email address you want on this account.'); bad = true; }
    else if (!A.validEmail(value)) { fieldError('ac-email-input', 'That email address looks incomplete — check for a typo in the domain.'); bad = true; }
    if (!password) { fieldError('ac-email-pw', 'Enter your current password to confirm this change.'); bad = true; }
    if (bad) return;
    UI.busy(emailSave, 'Saving…');
    api('/api/auth/email', { email: value, currentPassword: password }).then(function (data) {
      emailPw.value = ''; emailInput.value = '';
      emailForm.style.display = 'none';
      adopt(data);
      var delivery = (data && data.verification && data.verification.delivery) || '';
      if (delivery === 'failed' || delivery === 'skipped') {
        emailMessage('err', '<strong data-email></strong> is now on your account, but we could not send it a ' +
          'confirmation link. Try the resend button in a minute, or email <a href="mailto:info@clozo.ai">info@clozo.ai</a>.', value);
      } else {
        emailMessage('ok', '<strong data-email></strong> is now on your account. We sent it a confirmation ' +
          'link — it is valid for 24 hours.', value);
      }
      UI.idle(emailSave);
      if (bookMounted) bookCard();                           // FUNNEL-SPEC §8.9: a changed email → RB1 again (T4, EV10)
    }).catch(function (err) {
      if (bounceIfSignedOut(err)) return;
      if (err.code === 'email_in_use') fieldError('ac-email-input', 'That email is already on another account.');
      else if (err.code === 'invalid_email') fieldError('ac-email-input', 'Our server did not accept that address. Check the spelling, or try another.');
      else if (err.code === 'password_required' || err.status === 403) fieldError('ac-email-pw', 'That password is not right. Try again.');
      else if (isNetworkError(err)) emailMessage('err', 'We could not reach our servers. Check your connection and try again.');
      else emailMessage('err', esc(err.message || 'We could not save that address. Try again in a moment.'));
      UI.idle(emailSave);
    });
  });
  emailToggle.addEventListener('click', function () {
    var opening = emailForm.style.display === 'none';
    emailForm.style.display = opening ? '' : 'none';
    if (opening) emailInput.focus();
  });
  resendBtn.addEventListener('click', function () {
    emailMessage();
    UI.busy(resendBtn, 'Sending…');
    api('/api/auth/verify/resend', {}).then(function (data) {
      var v = data && data.verification;
      lastVerification = v || lastVerification;
      var delivery = (v && v.delivery) || '';
      if (delivery === 'failed' || delivery === 'skipped') {
        emailMessage('err', 'We could not send the confirmation email. Your account is fine — email ' +
          '<a href="mailto:info@clozo.ai">info@clozo.ai</a> and we will confirm the address by hand.');
      } else if (delivery === 'throttled') {
        emailMessage('ok', 'A link went out in the last few minutes, so we have not sent another. Check your ' +
          'spam folder — you can request a fresh one every 5 minutes.');
      } else if ((v && v.state) === 'verified') {
        emailMessage('ok', 'This address is already confirmed — there was nothing to send.');
      } else {
        emailMessage('ok', 'A new confirmation link is on its way to <strong data-email></strong>. It is valid for 24 hours.',
          (currentUser && currentUser.email) || '');
      }
      renderEmail(currentUser, lastVerification);
      UI.idle(resendBtn);
    }).catch(function (err) {
      if (bounceIfSignedOut(err)) return;
      emailMessage('err', isNetworkError(err)
        ? 'We could not reach our servers. Check your connection and try again.'
        : esc(err.message || 'We could not send that link just now. Try again in a moment.'));
      UI.idle(resendBtn);
    });
  });
  marketingEl.addEventListener('change', function () {
    var wanted = marketingEl.checked;
    marketingErr.textContent = '';
    marketingEl.disabled = true;
    api('/api/auth/marketing', { optIn: wanted }).then(function (data) {
      adopt(data);
      marketingEl.disabled = false;
    }).catch(function (err) {
      if (bounceIfSignedOut(err)) return;
      marketingEl.checked = !wanted;
      marketingEl.disabled = false;
      marketingErr.textContent = isNetworkError(err)
        ? 'We could not reach our servers, so that preference was not saved.'
        : (err.message || 'We could not save that preference. Try again in a moment.');
    });
  });
  logoutBtn.addEventListener('click', function () {
    UI.busy(logoutBtn, 'Logging out…');
    try { sessionStorage.removeItem(CACHE_KEY); } catch (_) {}
    A.logout().then(function () { location.replace('/index.html'); });
  });

  setIdentity(A.currentUser());
  A.me().then(adopt).catch(function (err) { if (err && err.status === 401) bounce(); });

  /* =====================================================================================================
     The summary (R12): cached paint, then the server's answer
     ===================================================================================================== */
  /* First paint (CLS < 0.05, DELTA-BRIEF-SITE item 21): the head guard hid the card's contents (html.cb-wait) so they
     appear once, already filled. Everything the first frame shows is set before the class goes — the summary, and the
     "Payment method updated." line a return from the portal carries in its URL (a cached paint shows it too; the
     summary is read again 2 s later, startupHash). */
  var revealed = false, pmUpdated = false, pmSessionID = null;
  function takePmFlag() {
    try {
      var url = new URL(location.href);
      var pm = url.searchParams.get('pm');
      if (pm !== 'updated' && pm !== 'added' && pm !== 'canceled') return;
      if (pm === 'updated') {
        pmUpdated = true;
        UI.notice($('ac-flash'), 'ok', 'Payment method updated.');
      } else if (pm === 'added') {
        // R41: back from Stripe's setup page — the list reads the session so the card shows before the webhook.
        var sid = url.searchParams.get('session_id');
        if (sid && /^cs_[A-Za-z0-9_]{1,250}$/.test(sid)) pmSessionID = sid;
        UI.notice($('ac-flash'), 'ok', 'Payment method added.');
      }
      url.searchParams.delete('pm');
      url.searchParams.delete('session_id');
      history.replaceState(history.state, '', url.pathname + (url.search || '') + url.hash);
    } catch (_) {}
  }
  function reveal() {
    if (revealed) return;
    revealed = true;
    takePmFlag();
    document.documentElement.classList.remove('cb-wait');
  }

  function who() { var u = A.currentUser() || {}; return String(u.id || u.email || u.username || ''); }
  function readCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.who === who() && Date.now() - c.at < 10 * 60 * 1000 && c.body && c.body.actions) return c.body;
    } catch (_) {}
    return null;
  }
  function writeCache(body) {
    try {
      var b = JSON.parse(JSON.stringify(body));
      if (b.actions) delete b.actions.download;   // a private download link never sits in storage (D20)
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ who: who(), at: Date.now(), body: b }));
    } catch (_) {}
  }
  function clearCache() { try { sessionStorage.removeItem(CACHE_KEY); } catch (_) {} }

  var inflight = null;
  function load(first) {
    var p;
    if (first && window.__clozoSummary && typeof window.__clozoSummary.then === 'function') {
      p = window.__clozoSummary;
      window.__clozoSummary = null;
    } else {
      p = UI.api('GET', '/api/billing/summary' + tzq(), undefined, { timeoutMs: 15000 });
    }
    return p.then(function (r) { return r || { status: 0, ok: false, data: {}, network: true }; });
  }
  /* "Your free book" (W7; FUNNEL-SPEC §8.9): mounted after the R12 summary has rendered (RB1 after the page's own content,
     2-s budget in book.js); every later render (after an account action) re-reads RB1. Hidden unless it rendered. */
  var bookMounted = false;
  function bookCard() {
    var bt = window.BookTracker, sec = $('book'), slot = $('ac-book-mount');
    if (!bt || !sec || !slot) return Promise.resolve(false);
    function onBook(m) {
      var pw = $('ac-pw-book'); if (pw) pw.hidden = !m.macOpen;
      var off = $('ac-book-reminders-off'); if (off) off.hidden = !m.remindersOff;
    }
    var p;
    if (!bookMounted) { bookMounted = true; p = bt.mount(slot, { placement: 'account', variant: 'card', level: 'h3', onRender: onBook }); }
    else { bt.invalidate(); p = bt.refresh(true); }
    return Promise.resolve(p).then(function () {
      sec.hidden = slot.hidden || !slot.firstChild;
      return !sec.hidden;
    }, function () { sec.hidden = true; return false; });
  }
  function refresh() {
    if (inflight) return inflight;
    inflight = load(false).then(apply, function () { return null; });
    inflight.then(function () { inflight = null; }, function () { inflight = null; });
    return inflight;
  }
  function apply(r) {
    if (r.status === 401) { bounce(); return null; }
    if (r.ok && r.data && r.data.actions) {
      S = r.data; fresh = true;
      writeCache(S);
      render();
      return S;
    }
    if (r.status === 404 || r.status === 501) { legacy(); return null; }
    if (!S) renderUnavailable();
    UI.notice($('ac-billing-note'), 'info', MSG.unavailable);
    return null;
  }

  /* An older server without R12 (mid-deploy): show the plan from GET /api/me, no billing actions. */
  function legacy() {
    A.entitlement().then(function (ent) {
      var plan = (ent && ent.plan) || {};
      var id = String(plan.planID || '').toLowerCase();
      var paid = id === 'monthly' || id === 'yearly';
      badgeEl.textContent = paid ? (plan.name || PLAN_NAMES[id]) : 'Not active';
      badgeEl.className = 'plan-badge' + (paid ? '' : ' free');
      setChip(paid ? 'Active' : 'Not active', paid ? 'ok' : 'muted');
      $('ac-plan-line').textContent = paid ? (plan.name || PLAN_NAMES[id]) : 'No active plan on this account.';
      $('plan').setAttribute('aria-busy', 'false');
      $('plan').classList.add('is-filled');
      UI.notice($('ac-billing-note'), 'info', MSG.unavailable);
      reveal();
      whenReady(renderAffiliate);   // UX-m9
    }).catch(function (err) { if (err && err.status === 401) bounce(); else renderUnavailable(); });
  }
  function renderUnavailable() {
    badgeEl.textContent = 'Account';
    badgeEl.className = 'plan-badge free';
    setChip('Unavailable', 'muted');
    $('ac-plan-line').textContent = 'Couldn’t load plan details.';
    $('plan').setAttribute('aria-busy', 'false');
    $('plan').classList.add('is-filled');
    reveal();
    whenReady(renderAffiliate);   // UX-m9: the affiliate card does not depend on the billing summary
  }

  /* =====================================================================================================
     Rendering
     ===================================================================================================== */
  function setChip(text, kind) { var c = $('ac-chip'); c.textContent = text; c.className = 'cb-chip ' + (kind || 'muted'); }
  function actionButton(label, cls, onClick, obs) {
    var b = UI.button(label, cls, function () { if (!fresh) return; onClick(b); }, { 'data-obs': obs || null });
    if (!fresh) b.disabled = true;
    return b;
  }
  function linkButton(label, onClick, obs) {
    var b = el('button', { type: 'button', className: 'cb-linkbtn', text: label, 'data-obs': obs || null, onClick: function () { if (fresh) onClick(b); } });
    if (!fresh) b.disabled = true;
    return b;
  }

  function render() {
    if (!S) return;
    var plan = $('plan');
    plan.setAttribute('aria-busy', fresh ? 'false' : 'true');
    renderHeader();
    renderMeter();
    renderFacts();
    renderLiveSubscriptions();
    renderResume();
    renderActions();
    renderPause();   // WP-PAUSE: placed before [Keep my plan]'s box (insertBefore), whatever the call order
    renderPayment();
    renderChoose();
    renderPassword();
    renderPaymentPanel();
    renderCancel();
    var note = $('ac-billing-note');
    if (S.degraded) UI.notice(note, 'info', MSG.unavailable); else if (fresh) note.hidden = true;
    plan.classList.add('is-filled');
    reveal();
    if (fresh) renderGetApp();
    if (fresh) mountPaymentMethods();
    if (fresh) {
      whenReady(function () {
        pendingCelebrations();
        var bookP = bookCard(), affCard = renderAffiliate();
        if (!hashDone) { hashDone = true; if (currentHash() === 'book') bookP.then(startupHash); else if (currentHash() === 'affiliate') affCard.then(startupHash); else startupHash(); }
      });
    } else whenReady(renderAffiliate);   // UX-m9 (fix round): a cached / degraded summary never hides the affiliate entry point
  }

  /* The Affiliate card (owner messages 15/16; CONTRACT-SITE §4.16; R2031 owner ruling D1): every account IS an affiliate — the card
     shows the live link, Copy link, pending / paid to date and "Open your affiliate dashboard". ONE GET /api/affiliates/me after the
     first fresh summary; a 404 affiliate_not_enrolled from an older server reads "being set up" (never a press to turn it on); any
     other answer keeps the card hidden. Never entitlement-gated, never a payment control (the payout method lives in the dashboard). */
  var affP = null;
  function renderAffiliate() {
    if (affP) return affP;
    var sec = $('affiliate'), line = $('ac-aff-line'), link = $('ac-aff-link'), lab = document.querySelector('#ac-aff-open .btn-label');
    if (!sec || !line || !A.safeCall) return Promise.resolve(false);
    function pct(bps) { return (Math.round(Number(bps) || 0) / 100) + '%'; }
    affP = A.safeCall('/api/affiliates/me', { auth: true }).then(function (r) {
      var d = (r && r.data) || {};
      if (r && r.ok && d.affiliate) {
        var code = (d.link && d.link.code) || d.affiliate.code || '';
        if (d.affiliate.status === 'closed') { line.textContent = 'Your affiliate account is closed.'; link.hidden = true; }
        else {
          var b = d.balance || {}, url = (d.link && d.link.url) || 'https://interview.clozo.ai/?via=' + code;
          line.textContent = 'Your link earns ' + pct((d.effective || {}).commissionBps) + ' of every payment from the customers you refer, for as long as they stay. Pending: ' + money(b.pendingCents || 0) + ' · paid to date: ' + money(b.paidOutCents != null ? b.paidOutCents : b.paidCents || 0) + '.';
          link.textContent = url.replace(/^https?:\/\//, ''); link.hidden = !code;
          if (code) {   // UX-m9 / R045: copy the live link from the account page
            var done = function () { cb.textContent = 'Copied'; setTimeout(function () { cb.textContent = 'Copy link'; }, 1600); };
            var cb = el('button', { type: 'button', className: 'cb-linkbtn', text: 'Copy link', onClick: function () {
              try { navigator.clipboard.writeText(url).then(done, function () {}); } catch (e) {
                try { var ta = document.createElement('textarea'); ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove(); done(); } catch (x) {}
              }
            } });
            link.appendChild(document.createTextNode(' ')); link.appendChild(cb);
          }
        }
        if (lab) lab.textContent = 'Open your affiliate dashboard';
      } else if (r && r.status === 404 && d.code === 'affiliate_not_enrolled') {
        line.textContent = 'Every account is an affiliate: your link earns ' + pct((d.enrol || {}).percentBps || 2000) + ' of every payment it refers. It is being set up right now — open your affiliate dashboard to see it.';
        link.hidden = true;
        if (lab) lab.textContent = 'Open your affiliate dashboard';
      } else return false;
      sec.hidden = false;
      return true;
    }, function () { return false; });
    return affP;
  }

  /* "Get the app" (D20, W8): the private R40 link comes only from a FRESH R12 (the cache holds none) — app-download.js
     renders #ac-download from this body; [Open Interview Clozo] (R35) shows on a Mac for an eligible account. */
  function renderGetApp() {
    var ad = window.clozoAppDownload;
    if (ad && typeof ad.render === 'function') ad.render(S); else window.__clozoAppDlPending = S;
    var d = (S.actions && S.actions.download) || {};
    var open = $('ac-open-app');
    var mac = ad && typeof ad.isMac === 'function' ? ad.isMac() : (UI.isMac ? UI.isMac() : false);
    // D-FS1-1 (FS1 #8): the hand-off button only when the published app takes it; otherwise the sentence they can act on.
    var handoff = !!(UI && typeof UI.appHandoff === 'function' && UI.appHandoff());
    if (open) open.hidden = !(d.available && mac && handoff);
    var openFallback = $('ac-open-fallback');   // D-FS3-020: an older app opens without signing in
    if (openFallback) openFallback.hidden = !(open && !open.hidden);
    var line = $('ac-mac-signin'), lineEmail = $('ac-mac-email');
    if (line) line.hidden = !(d.available && !handoff);
    if (lineEmail) lineEmail.textContent = email();
  }
  /* FS1 #26: "Add this purchase" — POST /activate with the web session; the server's own words on each refusal. */
  (function () {
    var form = $('ac-activate-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('ac-activate-code'), save = $('ac-activate-save'), msg = $('ac-activate-msg');
      fieldError('ac-activate-code', '');
      msg.hidden = true;
      var code = (input.value || '').trim();
      if (!/^ict_[0-9a-f]{24}$/i.test(code)) { fieldError('ac-activate-code', 'The code starts with ict_ and is in the email we sent you.'); input.focus(); return; }
      if (!A || typeof A.activate !== 'function') return;
      track('activate');
      UI.busy(save, 'Adding…');
      A.activate(code.toLowerCase()).then(function (r) {
        UI.idle(save);
        var d = (r && r.data) || {};
        if (r && r.ok) {
          track('activate', 'ok');
          input.value = '';
          UI.notice(msg, 'ok', 'Added. Your plan is on this account now, and your download is above.');
          clearCache();
          refresh();
          return;
        }
        if (r && r.status === 401) { bounce(); return; }
        track('activate', 'error', (typeof d.code === 'string' && d.code) || String(r && r.status) || undefined);
        var text = r && r.status === 404 ? 'We don\u2019t recognise that code. Check the email we sent you and try again.'
          : r && r.status === 402 ? 'That purchase has not been paid yet.'
          : r && r.status === 409 ? 'That code was already used on another account.'
          : (typeof d.message === 'string' && d.message) || 'We couldn\u2019t add it just now. Please try again in a minute.';
        UI.notice(msg, 'error', text);
      });
    });
  })();
  (function () {
    var open = $('ac-open-app');
    if (!open) return;
    open.addEventListener('click', function () {
      if (!A || typeof A.appLink !== 'function' || open.getAttribute('aria-busy') === 'true') return;
      track('open_app');
      open.setAttribute('aria-busy', 'true');
      var out = $('ac-download-status'); if (out) out.hidden = true;
      A.appLink().then(function (r) {
        open.removeAttribute('aria-busy');
        if (r && r.ok && r.data && r.data.code) {
          track('open_app', 'ok');
          window.__clozoLastDeepLink = 'interview://signin#c=' + encodeURIComponent(r.data.code);
          try { window.location.href = window.__clozoLastDeepLink; } catch (_) {}
          return;
        }
        if (out) { out.textContent = (r && r.data && typeof r.data.message === 'string' && r.data.message) || 'We couldn\u2019t open the app just now. Please try again.'; out.hidden = false; }
      });
    });
  })();

  function renderHeader() {
    // WP-PAUSE (owner ruling FM-D12): a paused plan is kept — it shows its own name and "Paused until {date}", never "Not active".
    var pz = S.pause;
    if (pz && pz.state === 'paused') {
      var pn = (pz.plan && pz.plan.name) || planName();
      badgeEl.textContent = pn;
      badgeEl.className = 'plan-badge';
      setChip(pz.untilMillis ? 'Paused until ' + UI.shortDay(pz.untilMillis) : 'Paused', 'muted');
      $('ac-plan-line').textContent = pn + ' · paused';
      return;
    }
    var paid = entitled();
    badgeEl.textContent = paid ? planName() : 'Not active';
    badgeEl.className = 'plan-badge' + (!paid ? ' free' : (S.payment ? ' warn' : ''));
    var end = endMillis();
    if (S.payment) setChip('Payment problem', 'warn');
    else if (trialing()) setChip(S.cancelAtPeriodEnd ? 'Ends ' + UI.shortDay(end) : 'Free trial', S.cancelAtPeriodEnd ? 'muted' : 'ok');
    else if (paid && (S.cancelAtPeriodEnd || S.cancellation)) setChip('Ends ' + UI.shortDay(end), 'muted');
    else if (paid && st() === 'active' && pz && pz.state === 'scheduled') setChip('Pauses ' + UI.shortDay(pz.startsAtMillis), 'muted');
    else if (paid && st() === 'active') setChip('Active', 'ok');
    else if (paid) setChip('Payment problem', 'warn');
    else setChip('Not active', 'muted');
    var line = $('ac-plan-line');
    if (paid && S.plan && typeof S.plan.priceCents === 'number') {
      line.textContent = planName() + ' · ' + money(S.plan.priceCents, currency()) + ' per ' + UI.per(S.plan.interval);
    } else if (paid) {
      line.textContent = planName();
    } else {
      line.textContent = 'No active plan on this account.';
    }
  }

  /* The trial meter (R12 trial.meterText verbatim — the one sentence every surface shows) + LEGAL-COPY §9.1's detail
     line. Cyan, amber on the last interview or in the last 3 days; never red, never a countdown. */
  function renderMeter() {
    var box = $('ac-meter');
    var t = S.trial;
    if (!trialing() || !t) { box.hidden = true; return; }
    var limit = typeof t.interviewsLimit === 'number' ? t.interviewsLimit : 3;
    var used = Math.min(limit, Math.max(0, t.interviewsUsed || 0));
    var left = limit - used;
    var segs = $('ac-segs');
    segs.textContent = '';
    for (var i = 0; i < limit; i++) segs.appendChild(el('span', { className: 'cb-seg' + (i < used ? ' is-used' : '') }));
    var daysLeft = typeof t.daysLeft === 'number' ? t.daysLeft : null;
    var pct = daysLeft === null ? 0 : Math.max(0, Math.min(1, (14 - daysLeft) / 14));
    $('ac-days-fill').style.width = Math.round(pct * 100) + '%';
    box.classList.toggle('is-amber', left <= 1 || (daysLeft !== null && daysLeft <= 3));
    $('ac-meter-text').textContent = t.meterText || '';
    var trialEnd = day(t.endsAtMillis);
    var amount = money(S.nextCharge ? S.nextCharge.amountCents : t.chargeAmountCents, t.currency || currency());
    var pm = pmLabel() || 'your payment method';
    var detail;
    if (S.cancelAtPeriodEnd) detail = 'You can use any trial interviews you have left until ' + trialEnd + '.';
    else if (left >= 1) detail = 'Then ' + planName() + ': ' + amount + ', charged automatically to ' + pm + ' on ' + trialEnd +
      ' unless you cancel. Trial interviews stop automatically at 50 minutes.';
    else detail = 'Your ' + limit + ' trial interviews are used. Your ' + planName() + ' plan starts on ' + trialEnd + ' (' + amount +
      ', charged automatically), or sooner if you start your next interview or press Start plan now.';
    $('ac-meter-detail').textContent = detail;
    box.hidden = false;
  }

  function fact(dl, k, v, sub) {
    if (!v) return;
    var dd = el('dd', null, [el('span', { text: v })]);
    if (sub) dd.appendChild(el('span', { className: 'cb-sub', text: sub }));
    dl.appendChild(el('div', { className: 'cb-fact' }, [el('dt', { text: k }), dd]));
  }
  function renderFacts() {
    var dl = $('ac-facts');
    dl.textContent = '';
    if (!entitled()) { dl.hidden = true; return; }
    var nc = S.nextCharge;
    if (nc && !trialing()) {
      var who = pmLabel() ? ', charged automatically to ' + pmLabel() : ', charged automatically';
      var sub = nc.discount && nc.discount.mechanism === 'stripe_coupon_once' ? '25% off, once' : null;
      fact(dl, 'Next charge', money(nc.amountCents, nc.currency) + ' on ' + day(nc.atMillis) + who, sub);
    } else if (nc && trialing() && nc.discount) {
      fact(dl, 'First charge', money(nc.amountCents, nc.currency) + ' on ' + day(nc.atMillis), nc.discount.mechanism === 'stripe_coupon_once' ? '25% off, once' : null);
    } else if (!trialing() && (S.cancelAtPeriodEnd || S.cancellation)) {
      fact(dl, 'Next charge', 'None — your plan ends on ' + day(endMillis()));
    }
    var pm = S.paymentMethod;
    var pmText = pmLabel();
    if (pm && pm.expMonth && pm.expYear) {
      var expEnd = new Date(pm.expYear, pm.expMonth, 1).getTime();
      if (expEnd - Date.now() < 60 * 86400000) pmText += ' · expires ' + String(pm.expMonth).padStart(2, '0') + '/' + String(pm.expYear).slice(-2);
    }
    fact(dl, 'Payment method', pmText);
    dl.hidden = !dl.firstChild;
  }

  /* Billing v2 WP4 (b) (A4-N05): EVERY live subscription of this account AND its email. R12 sends `liveSubscriptions`
     only when there is one the plan line above does not show: a purchase made signed out with this email stays off the
     account (D15.15). Visibility only: no button and no link here. The ONE Cancel subscription below (the normal flow)
     ends all of them. Text only, the server's facts (a short ref, never an id). */
  function liveSubscriptionLine(x, fmt) {
    var plan = x.planID === 'yearly' ? 'Yearly' : x.planID === 'monthly' ? 'Monthly' : (x.planName || 'Plan');
    var parts = [plan];
    if (typeof x.priceCents === 'number') parts.push(fmt.money(x.priceCents, x.currency || 'usd') + ' per ' + fmt.per(x.interval));
    var end = x.periodEndMillis ? fmt.day(x.periodEndMillis) : '';
    var st = String(x.status || '').toLowerCase();
    if (x.cancelAtPeriodEnd) parts.push(end ? 'ends on ' + end + ', no further charges' : 'set to end, no further charges');
    else if (x.trialing) parts.push(end ? 'free trial, charged automatically on ' + end : 'free trial');
    else if (st === 'pastdue' || st === 'incomplete') parts.push('payment overdue');
    else if (end) parts.push('next charge ' + end);
    parts.push(x.onThisAccount ? 'on this account' : 'bought with this email, not on this account');
    return parts.join(' · ') + (x.ref ? ' (ref ' + x.ref + ')' : '');
  }
  function renderLiveSubscriptions() {
    var box = $('ac-live-subs');
    var ls = S && S.liveSubscriptions;
    var items = ls && Array.isArray(ls.items) ? ls.items.filter(function (x) { return x && typeof x === 'object'; }) : [];
    if (!items.length) { if (box) box.hidden = true; return; }
    if (!box) {
      var facts = $('ac-facts');
      box = el('div', { className: 'cb-live-subs', id: 'ac-live-subs' });
      facts.parentNode.insertBefore(box, facts.nextSibling);
    }
    box.textContent = '';
    var fmt = { money: money, day: day, per: UI.per };
    box.appendChild(el('p', { className: 'cb-detail', text: items.length === 1 ? 'Billed to this email:' : items.length + ' subscriptions are billed to this email:' }));
    box.appendChild(el('ul', { className: 'cb-live-list' }, items.map(function (x) { return el('li', { className: 'cb-detail', text: liveSubscriptionLine(x, fmt) }); })));
    var open = items.filter(function (x) { return !x.cancelAtPeriodEnd; }).length;
    if (open > 1) box.appendChild(el('p', { className: 'cb-detail', text: 'Cancel subscription below ends all of them.' }));
    box.hidden = false;
  }

  /* [Keep my plan] (R16): one click, the server's sentence beside the button (LEGAL-COPY §8.6), no dialog. */
  function renderResume() {
    var box = $('resume');
    var rv = acts().resume;
    box.textContent = '';
    if (!rv || !rv.available) { box.hidden = true; return; }
    if (!trialing()) box.appendChild(el('p', { className: 'cb-resume-lead', text: 'Your plan ends on ' + day(endMillis()) + '. You won’t be charged again.' }));
    box.appendChild(el('p', { className: 'cb-confirm', text: rv.confirmText || '' }));
    var b = actionButton(rv.buttonLabel || 'Keep my plan', 'btn btn-primary', doResume, 'keep-my-plan');
    box.appendChild(el('div', { className: 'cb-actions' }, [b]));
    if (rv.termsText) box.appendChild(el('p', { className: 'cb-terms', text: rv.termsText }));
    box.appendChild(UI.agreement(rv.agreementText));
    box.hidden = false;
  }

  /* WP-PAUSE (owner ruling FM-D12): a pause chosen in the cancel flow's offer step — "Paused until {date}" (or "Pauses on …
     until …" before it starts), the server's sentence, and Resume as ONE click with the server's words beside the button,
     no dialog (as [Keep my plan]). R12 `pause`; POST /api/billing/pause/resume. Every sentence is the server's, as text. */
  function renderPause() {
    var box = $('ac-pause');
    var p = S && S.pause;
    if (!p || (p.state !== 'paused' && p.state !== 'scheduled')) { if (box) box.hidden = true; return; }
    if (!box) {
      var anchor = $('resume');
      box = el('div', { className: 'cb-resume cb-pause', id: 'ac-pause', tabindex: '-1' });
      anchor.parentNode.insertBefore(box, anchor);
    }
    box.textContent = '';
    box.appendChild(el('p', { className: 'cb-resume-lead', text: p.label || '' }));
    if (p.text) box.appendChild(el('p', { className: 'cb-confirm', text: p.text }));
    var rv = p.resume || {};
    if (rv.available) {
      if (rv.confirmText) box.appendChild(el('p', { className: 'cb-confirm', text: rv.confirmText }));
      var b = actionButton(rv.buttonLabel || 'Resume my plan', 'btn btn-primary', function (btn) { doResumePause(btn); }, 'resume-pause');
      box.appendChild(el('div', { className: 'cb-actions' }, [b]));
      if (rv.termsText) box.appendChild(el('p', { className: 'cb-terms', text: rv.termsText }));
      if (rv.agreementText) box.appendChild(UI.agreement(rv.agreementText));
    }
    box.hidden = false;
  }
  function doResumePause(btn) {
    var rv = S && S.pause && S.pause.resume;
    if (!rv || !rv.available) return;
    UI.busy(btn, 'Working…');
    var body = { confirm: true, surface: 'web', consentVersion: rv.consentVersion };
    if (rv.chargesNow) body.expectedAmountCents = rv.amountCents;
    var tz = UI.timeZone ? UI.timeZone() : null;
    if (tz) body.timeZone = tz;
    UI.api('POST', '/api/billing/pause/resume', body, { timeoutMs: 60000 }).then(function (r) {
      var d = r.data || {};
      UI.idle(btn);
      if (r.ok && d.ok) {
        clearCache();
        result('ok', d.charged ? 'Your plan is back on. ' + money(d.chargedAmountCents, d.currency || currency()) + ' was charged today.' : 'Your plan won’t pause. It carries on as before.');
        refresh();
        return;
      }
      if (r.status === 401) { bounce(); return; }
      var code = d.code || d.error || '';
      if (r.status === 409 && (code === 'disclosure_changed' || code === 'amount_changed' || code === 'not_paused')) { clearCache(); refresh(); }
      result(r.status === 402 ? 'error' : 'warn', d.message || (r.network ? MSG.network : MSG.generic));
    });
  }

  function renderActions() {
    var row = $('ac-actions');
    row.textContent = '';
    var a = acts();
    var sp = a.startPlanNow, sy = a.switchYearly || {};
    if (sp && sp.available) {
      row.appendChild(actionButton('Start plan now', 'btn btn-primary', function () { openStartPlan(false); }, 'start-plan-now'));
      if (sp.yearly && planID() === 'monthly') row.appendChild(actionButton('Start Yearly now', 'btn btn-secondary', function () { openStartPlan(true); }, 'start-yearly-now'));
    }
    if (sy.available && sy.method === 'inline') row.appendChild(actionButton('Switch to Yearly', 'btn btn-primary', function () { openSwitch(); }, 'switch-yearly'));
    (sy.alternatives || []).forEach(function (alt) {
      if (!alt || alt.provider !== 'stripe') return;   // Stripe is the one checkout (billing v2 WP10 slice C)
      row.appendChild(actionButton('Switch to Yearly with card or Link', 'btn btn-secondary', function () { openSwitchR3(alt, alt.provider, 'switch_yearly_other_provider'); },
        'switch-yearly-card'));
    });
    var primary = (sp && sp.available) ? 'start-plan' : (sy.available && sy.method === 'inline') ? 'switch-yearly' : null;
    if (primary && stripePortal()) {
      row.appendChild(linkButton('Use another card or Link', function () { useAnotherMethod(primary); }, 'use-another-method'));
    }
    row.hidden = !row.firstChild;
  }

  /* A kept plan whose payment failed (§3.5): retrying / paused / first_charge_unpaid. */
  function renderPayment() {
    var box = $('pay-overdue');
    box.textContent = '';
    var p = S.payment;
    if (!p) { box.hidden = true; return; }
    box.appendChild(el('p', { text: p.message || '' }));
    var po = acts().payOverdue;
    var row = el('div', { className: 'cb-actions' });
    if (po && po.available) row.appendChild(actionButton('Pay now', 'btn btn-primary', function () { openPayOverdue(); }, 'pay-overdue'));
    if (stripePortal()) row.appendChild(linkButton('Use another card or Link', function () { useAnotherMethod('pay-overdue'); }, 'use-another-method'));
    if (row.firstChild) box.appendChild(row);
    box.className = 'cb-alert warn cb-pay';
    box.hidden = false;
  }

  /* No plan: Start Free Trial (never trialed, D19.1), renew (R34 with the saved card / R3 checkout). */
  function renderChoose() {
    var box = $('choose-plan'), rows = $('ac-choose-rows');
    rows.textContent = '';
    var a = acts();
    var trialOK = !!(a.startTrial && a.startTrial.available);
    var renewOK = !!(a.renew && a.renew.available);
    if (entitled() || S.payment || !(trialOK || renewOK)) { box.hidden = true; return; }
    // A2-12 (owner ruling D17.2): an account whose free trial is used (R12 renew available, startTrial not — the same
    // canTrial test as R3's 409 trial_already_used, which lands here as #choose-plan) is told why there is no Start Free
    // Trial and that a plan is billed today: choose-your-plan words, as the Mac app says (OnboardingPlanStep.usedTrialSentence).
    if (renewOK && a.startTrial && a.startTrial.available === false) {
      rows.appendChild(el('p', { className: 'cb-detail', id: 'ac-choose-used', text: 'This account has already had its free trial. Subscribing starts now and is billed today.' }));
    }
    var needsCatalog = false;
    ['monthly', 'yearly'].forEach(function (id) {
      var price = priceOf(id);
      if (price === null) needsCatalog = true;
      var btns = el('div', { className: 'cb-plan-row-btns' });
      if (trialOK && (a.startTrial.planIDs || ['monthly', 'yearly']).indexOf(id) !== -1) {
        btns.appendChild(actionButton('Start Free Trial', 'btn btn-primary', function (b) { startTrial(id, 'account', b); }, 'start-trial-' + id));
      } else if (renewOK && a.renew.inline && a.renew.inline[id]) {
        btns.appendChild(actionButton('Renew ' + PLAN_NAMES[id], 'btn btn-primary', function () { openRenewInline(id); }, 'renew-inline-' + id));
      } else if (renewOK) {
        btns.appendChild(actionButton('Renew ' + PLAN_NAMES[id], 'btn btn-primary', function (b) { renewCheckout(id, b); }, 'renew-' + id));
      }
      rows.appendChild(el('div', { className: 'cb-plan-row' }, [
        el('div', { className: 'cb-plan-row-name' }, [
          el('span', { className: 'cb-plan-row-title', text: PLAN_NAMES[id] }),
          el('span', { className: 'cb-plan-row-price', 'data-price-for': id, text: price === null ? '' : money(price, 'usd') + ' per ' + (id === 'yearly' ? 'year' : 'month') })
        ]),
        btns
      ]));
    });
    if (renewOK && a.renew.inline && stripePortal() && !trialOK) {
      rows.appendChild(el('p', { className: 'cb-extra' }, [
        'Paying with ' + ((a.renew.inline.paymentMethod && a.renew.inline.paymentMethod.label) || pmLabel() || 'your saved payment method') + ' · ',
        linkButton('Use another card or Link', function () { useAnotherMethod('renew'); }, 'use-another-method')
      ]));
    }
    rows.appendChild(UI.agreement(UI.AGREEMENT));
    box.hidden = false;
    if (needsCatalog) fillCatalogPrices();
  }
  function priceOf(id) {
    var inl = acts().renew && acts().renew.inline;
    if (inl && inl[id] && typeof inl[id].amountCents === 'number') return inl[id].amountCents;
    if (S.plan && S.plan.planID === id && typeof S.plan.priceCents === 'number' && S.plan.priceCents > 0) return S.plan.priceCents;
    if (catalog && catalog[id]) return catalog[id];
    return null;
  }
  function fillCatalogPrices() {
    if (catalog) return;
    catalog = {};
    UI.api('GET', '/api/plans', undefined, { timeoutMs: 8000 }).then(function (r) {
      var list = (r.ok && r.data && r.data.plans) || [];
      list.forEach(function (p) { if (p && (p.planID === 'monthly' || p.planID === 'yearly') && typeof p.priceCents === 'number') catalog[p.planID] = p.priceCents; });
      ['monthly', 'yearly'].forEach(function (id) {
        var span = document.querySelector('[data-price-for="' + id + '"]');
        if (span && !span.textContent && catalog[id]) span.textContent = money(catalog[id], 'usd') + ' per ' + (id === 'yearly' ? 'year' : 'month');
      });
    });
  }

  function renderPassword() {
    var box = $('set-password');
    box.hidden = !(S.account && S.account.needsPassword);
    var pwUser = $('ac-pw-user');
    if (pwUser && !pwUser.value) pwUser.value = email();
  }

  /* Payment methods (R41, owner ruling 15): one list, the same as the app's (payment-methods.js), mounted once after the
     first fresh summary. A change there re-reads R12, so the plan card's "charged to …" names the new primary. */
  var pmWidget = null;
  function mountPaymentMethods() {
    if (pmWidget || !window.clozoPaymentMethods || !$('payment-methods')) return;
    pmWidget = window.clozoPaymentMethods.mount({
      root: $('payment-methods'), UI: UI, sessionID: pmSessionID,
      onChanged: function () { clearCache(); refresh(); },
      track: track
    });
    pmSessionID = null;
  }

  /* Invoices & receipts: the Interview Stripe portal (cancellation OFF there). The list above changes payment methods
     now (owner decision H-35 A); "Use another card or Link" beside a pay button still opens the portal's payment-method
     flow. */
  function renderPaymentPanel() {
    var box = $('update-payment'), text = $('ac-pm-text'), row = $('ac-pm-actions');
    row.textContent = '';
    var up = acts().updatePaymentMethod || {};
    var grid = $('ac-grid');
    if (up.available && up.method === 'stripe_portal') {
      text.textContent = 'Download invoices and receipts.';
      row.appendChild(actionButton('Invoices and receipts', 'btn btn-ghost btn-block', function (b) { portal({ returnTo: 'account' }, b, 'invoices'); }, 'invoices'));
      box.hidden = false;
    } else {
      box.hidden = true;
    }
    grid.classList.toggle('is-single', box.hidden);
  }

  function renderCancel() {
    var box = $('cancel-panel');
    var c = acts().cancel;
    if (!c || !c.available) { box.hidden = true; return; }
    var text;
    if (S.pause && S.pause.state === 'paused') text = 'Cancelling ends your paused plan now. Nothing more is charged.';   // WP-PAUSE
    else if (S.payment) text = 'Cancelling stops future charges.';
    else if (trialing()) text = 'Cancelling stops future charges. You can use any trial interviews you have left until ' + day(endMillis()) + '.';
    else text = 'Cancelling stops future charges. You keep access until the end of the period you’ve paid for.';
    $('ac-cancel-text').textContent = text;
    $('ac-cancel').disabled = !fresh;
    box.hidden = false;
  }

  /* =====================================================================================================
     Results, celebrations
     ===================================================================================================== */
  function result(kind, text, link) { UI.notice($('ac-result'), kind, text, link); }
  function after(action, ok, successLine, data) {
    if (!ok) return;
    track(action, 'ok');
    clearCache();
    if (successLine) result('ok', successLine);
    var c = data && data.celebrate;
    if (c && c.id && c.playOn !== 'app') {
      whenVisible(function () {
        UI.celebrate({ id: c.id, kind: c.kind, planID: data.planID || planID(), createdAtMillis: Date.now() },
          { slot: $('ac-celebrate'), delayed: false, trialEndMillis: S && S.trial && S.trial.endsAtMillis });
        UI.api('POST', '/api/billing/celebrations/' + encodeURIComponent(c.id) + '/ack', { surface: 'web' });
      });
      celebratedThisView = true;
    }
    refresh();
  }
  /* Pending rows (automatic renewal, day-14 conversion, …): ack FIRST, play only on firstShow; one per page view; an
     in-app purchase's row is left to the app for 24 h (R33). */
  function pendingCelebrations() {
    if (celebratedThisView || !S || !Array.isArray(S.celebrations) || !S.celebrations.length) return;
    var now = Date.now();
    var list = S.celebrations.filter(function (c) {
      return c && c.id && !UI.alreadyCelebrated(c.id) && (c.playOn !== 'app' || now - (c.createdAtMillis || 0) > 24 * 3600 * 1000);
    }).sort(function (x, y) { return (y.createdAtMillis || 0) - (x.createdAtMillis || 0); });
    if (!list.length) return;
    var c = list[0];
    celebratedThisView = true;
    whenVisible(function () {
      UI.api('POST', '/api/billing/celebrations/' + encodeURIComponent(c.id) + '/ack', { surface: 'web' }).then(function (r) {
        if (!r.ok || !r.data || r.data.firstShow === false) return;
        UI.celebrate(c, { slot: $('ac-celebrate'), delayed: true, trialEndMillis: S && S.trial && S.trial.endsAtMillis });
      });
    });
  }

  /* =====================================================================================================
     Money actions
     ===================================================================================================== */
  function textsOf(o, fallback) {
    if (!o) return fallback || null;
    var f = fallback || {};
    return {
      confirmText: o.confirmText || o.text || f.confirmText || '',
      termsText: o.termsText !== undefined ? o.termsText : (f.termsText || null),
      buttonLabel: o.buttonLabel || f.buttonLabel || '',
      agreementText: o.agreementText || f.agreementText || UI.AGREEMENT,
      consentVersion: o.consentVersion || f.consentVersion || '',
      startsAtMillis: typeof o.startsAtMillis === 'number' ? o.startsAtMillis : f.startsAtMillis
    };
  }
  function pmExtra(returnAction) {
    var label = pmLabel();
    if (!label && !stripePortal()) return null;
    return {
      label: label ? 'Paying with ' + label : 'Paying with your saved payment method',
      linkText: stripePortal() ? 'Use another card or Link' : null,
      onLink: function () { useAnotherMethod(returnAction); }
    };
  }
  /* One place that turns an action's answer into the dialog's next state. ctx.reload() → fresh texts after a refetch. */
  function outcome(action, r, ctx) {
    var d = r.data || {};
    var code = d.code || d.error || '';
    if (r.ok && d.ok) return { ok: true, result: d };
    if (r.status === 401) { bounce(); return { ok: false, message: 'For your security, please sign in again.' }; }
    if (r.network) return { ok: false, code: 'network', result: 'error', message: MSG.network };
    if (r.status === 402) {
      var declined = /declined/.test(code);
      return {
        ok: false, code: code, result: declined ? 'declined' : 'action_required',
        message: d.message || (declined ? 'Your bank declined this payment. Nothing has been charged.' : 'Your bank needs you to approve this payment.'),
        link: d.hostedInvoiceUrl ? { href: d.hostedInvoiceUrl, text: declined ? 'Pay on the secure payment page' : 'Approve payment', newTab: true } : null
      };
    }
    if (r.status === 409 && code === 'disclosure_changed') {
      return { ok: false, code: code, result: 'disclosure_changed', message: d.message || MSG.disclosure, texts: textsOf(d.disclosure || d, ctx && ctx.texts) };
    }
    if (r.status === 409 && (code === 'amount_changed' || code === 'preview_expired')) {
      return (ctx && ctx.reload ? ctx.reload() : Promise.resolve(null)).then(function (t) {
        var amt = typeof d.amountCents === 'number' ? d.amountCents : (t && t.amountCents);
        return { ok: false, code: code, result: 'amount_changed', texts: t || null, facts: t && t.facts,
          message: (typeof amt === 'number' ? 'The amount has changed to ' + money(amt, d.currency || currency()) + '. ' : 'The amount has changed. ') +
            'Nothing has been charged — please review it before you continue.' };
      });
    }
    if (r.status === 409 && code === 'cancel_scheduled') {
      refresh();
      return { ok: false, code: code, result: 'error', message: d.message || '', link: { text: 'Keep my plan', onClick: function () { closeAndFocus('resume'); } } };
    }
    if (r.status === 409) { refresh(); return { ok: false, code: code, result: 'error', message: d.message || 'That isn’t available for this plan any more. Nothing has been charged.' }; }
    if (r.status === 503 || r.status === 502) return { ok: false, code: code, result: 'error', message: d.message || MSG.provider };
    return { ok: false, code: code, result: 'error', message: d.message || MSG.generic };
  }
  function closeAndFocus(id) {
    var dlg = document.querySelector('.cb-dialog .cb-x');
    if (dlg) dlg.click();
    setTimeout(function () { focusSection(id); }, 50);
  }

  /* R13 — Start plan now (Stripe trial). The charge is never discounted (D15.6); Yearly from a Monthly trial is a switch. */
  function openStartPlan(yearly) {
    var sp = acts().startPlanNow;
    if (!sp || !sp.available) return false;
    var cur = yearly ? sp.yearly : sp;
    if (!cur) return false;
    var target = yearly ? 'yearly' : planID();
    var name = yearly ? 'Yearly' : planName();
    track('start_plan_now');
    var texts = textsOf(cur, { consentVersion: sp.consentVersion });
    UI.confirm({
      action: 'start_plan_now',
      title: 'Start your ' + name + ' plan now?',
      texts: texts,
      secondaryLabel: 'Keep my trial',
      extra: pmExtra('start-plan'),
      run: function (t) {
        return UI.api('POST', '/api/billing/start-plan-now', {
          confirm: true, planID: target, expectedAmountCents: cur.amountCents,
          consentVersion: t.consentVersion || sp.consentVersion, surface: 'web'
        }, { timeoutMs: 60000 }).then(function (r) {
          return outcome('start_plan_now', r, { texts: t, reload: function () {
            return refresh().then(function () {
              var n = acts().startPlanNow; var nc = n && (yearly ? n.yearly : n);
              if (!nc) return null;
              cur = nc;
              var x = textsOf(nc, { consentVersion: n.consentVersion }); x.amountCents = nc.amountCents;
              return x;
            });
          } });
        });
      }
    }).then(function (res) {
      after('start_plan_now', res.ok, res.ok ? 'Your ' + name + ' plan has started. We’ve emailed your receipt to ' + email() + '.' : null, res.result);
    });
    return true;
  }

  /* R14 preview → R15 — Monthly → Yearly now, prorated (Stripe). The switch itself is never discounted; an accepted 25%
     moves to the Yearly's first renewal and the server's texts say so (D21.1). */
  function openSwitch() {
    var sy = acts().switchYearly || {};
    if (!sy.available) return false;
    if (sy.method !== 'inline') return false;
    track('switch_yearly');
    var preview = null;
    function loadPreview() {
      return UI.api('GET', '/api/billing/switch-yearly/preview' + tzq(), undefined, { timeoutMs: 20000 }).then(function (r) {
        var d = r.data || {};
        if (r.ok && typeof d.amountDueCents === 'number') {
          preview = d;
          var t = textsOf(d); t.amountCents = d.amountDueCents;
          t.facts = [['Due today', money(d.amountDueCents, d.currency)], ['Yearly renews on', day(d.renewsAtMillis)],
                     ['Paying with', (d.paymentMethod && d.paymentMethod.label) || pmLabel()]];
          return { texts: t, facts: t.facts };
        }
        if (r.status === 401) { bounce(); return { message: 'For your security, please sign in again.' }; }
        if (r.status === 409) refresh();
        return { message: d.message || (r.network ? MSG.network : 'We couldn’t load the price. Nothing has been charged. Please try again in a moment.') };
      });
    }
    UI.confirm({
      action: 'switch_yearly',
      title: 'Switch to Yearly now?',
      texts: null,
      loadTexts: loadPreview,
      secondaryLabel: 'Keep Monthly',
      extra: pmExtra('switch-yearly'),
      run: function (t) {
        if (!preview) return Promise.resolve({ ok: false, message: MSG.generic });
        return UI.api('POST', '/api/billing/switch-yearly', {
          confirm: true, expectedAmountCents: preview.amountDueCents, prorationDate: preview.prorationDate,
          consentVersion: t.consentVersion, surface: 'web'
        }, { timeoutMs: 60000 }).then(function (r) {
          return outcome('switch_yearly', r, { texts: t, reload: function () {
            return loadPreview().then(function (x) {
              if (!x || !x.texts) return null;
              var m = x.texts; m.facts = x.facts;
              return m;
            });
          } });
        });
      }
    }).then(function (res) {
      after('switch_yearly', res.ok, res.ok ? 'You’re on Yearly. We’ve emailed your receipt to ' + email() + '.' : null, res.result);
    });
    return true;
  }

  /* R3 from this page (signed in, surface web): the texts beside the button are the server's; the echo carries
     consentVersion (+ startsAtMillis for a switch). A success leaves for Stripe. */
  function r3(body) {
    UI.track('checkout_started', { planID: body.plan, provider: body.provider, trial: !!body.trial, entry: body.entry });
    try {
      if (window.clozo && typeof window.clozo.track === 'function') {
        window.clozo.track('checkout_start', { plan: body.plan, provider: body.provider, source: 'account', trial: !!body.trial, entry: body.entry });
      }
    } catch (_) {}
    var full = { plan: body.plan, provider: body.provider, surface: 'web', intent: body.intent, entry: body.entry };
    if (body.trial) full.trial = true;
    if (body.consentVersion) full.consentVersion = body.consentVersion;
    if (typeof body.startsAtMillis === 'number') full.startsAtMillis = body.startsAtMillis;
    var tz = UI.timeZone(); if (tz) full.timeZone = tz;
    return UI.api('POST', '/api/checkout', full, { timeoutMs: 30000 }).then(function (r) {
      var d = r.data || {};
      var code = d.code || d.error || '';
      if (r.ok && typeof d.url === 'string' && d.url) { location.assign(d.url); return { ok: true, result: { navigating: true } }; }
      if (r.status === 401) { bounce(); return { ok: false, message: 'For your security, please sign in again.' }; }
      if (r.network) return { ok: false, code: 'network', result: 'error', message: MSG.network };
      if (r.status === 409 && code === 'trial_already_used') {
        refresh();
        return { ok: false, code: code, result: 'error', message: d.message || 'This account has already had its free trial, so this plan starts with a payment today.' };
      }
      if (r.status === 409 && code === 'use_in_place_action') {
        refresh();
        return { ok: false, code: code, result: 'error', message: d.message || '', inPlace: d.action };
      }
      if (r.status === 409 && code === 'disclosure_changed') {
        return { ok: false, code: code, result: 'disclosure_changed', message: d.message || MSG.disclosure, texts: textsOf(d.disclosure || d, body.texts) };
      }
      if (r.status >= 500) return { ok: false, code: code, result: 'error', message: d.message || 'Checkout is temporarily unavailable — nothing was charged. Please try again in a moment.' };
      return { ok: false, code: code, result: 'error', message: d.message || 'Could not start checkout — nothing was charged. Please try again.' };
    });
  }
  function openInPlace(action) {
    if (action === 'start_plan_now') return openStartPlan(false);
    if (action === 'switch_yearly') return openSwitch();
    if (action === 'pay_overdue') return openPayOverdue();
    return false;
  }

  /* Monthly → Yearly through a card / Link checkout that starts when the Monthly ends (R12 switchYearly.alternatives).
     Nothing is charged today; the server's text says when the Yearly starts (D13.8, CROSS_PROVIDER_SWITCH). */
  function openSwitchR3(src, provider, action) {
    if (!src) return false;
    track(action);
    var texts = textsOf(src);
    UI.confirm({
      action: action,
      title: 'Switch to Yearly with card or Link?',
      texts: texts,
      secondaryLabel: null,
      run: function (t) {
        return r3({ plan: 'yearly', provider: provider, intent: 'switch', entry: 'account', consentVersion: t.consentVersion,
                    startsAtMillis: typeof t.startsAtMillis === 'number' ? t.startsAtMillis : src.startsAtMillis, texts: t });
      }
    }).then(function (res) { if (res.ok) track(action, 'ok'); });
    return true;
  }

  /* Start Free Trial (card or Link; one per account, D13.7). Stripe shows the trial terms next to its button. */
  function startTrial(id, entry, btn) {
    track('start_trial');
    if (btn) UI.busy(btn, 'Redirecting…');
    return r3({ plan: id, provider: 'stripe', trial: true, intent: 'trial', entry: entry || 'account' }).then(function (res) {
      if (res.ok) { track('start_trial', 'ok'); return; }
      if (btn) UI.idle(btn);
      track('start_trial', res.result || 'error', res.code);
      UI.notice($('ac-choose-result'), 'error', res.message || MSG.generic);
      if (res.inPlace) openInPlace(res.inPlace);
    });
  }
  /* Renew through Stripe Checkout (no reusable saved method): card, Link, Apple Pay; the terms sit beside Stripe's button. */
  function renewCheckout(id, btn) {
    track('renew');
    UI.busy(btn, 'Redirecting…');
    r3({ plan: id, provider: 'stripe', intent: 'renew', entry: 'account' }).then(function (res) {
      if (res.ok) { track('renew', 'ok'); return; }
      UI.idle(btn);
      track('renew', res.result || 'error', res.code);
      UI.notice($('ac-choose-result'), 'error', res.message || MSG.generic);
      if (res.inPlace) openInPlace(res.inPlace);
    });
  }

  /* R34 — renew with the saved card, one confirmation (LEGAL-COPY §8.5: no second control, only the x). */
  function openRenewInline(id) {
    var inl = acts().renew && acts().renew.inline;
    var cur = inl && inl[id];
    if (!cur) return false;
    track('renew_inline');
    UI.confirm({
      action: 'renew_inline',
      title: 'Renew your ' + PLAN_NAMES[id] + ' plan?',
      texts: textsOf(cur, { consentVersion: inl.consentVersion }),
      secondaryLabel: null,
      extra: pmExtra('renew'),
      run: function (t) {
        return UI.api('POST', '/api/billing/renew', {
          confirm: true, planID: id, expectedAmountCents: cur.amountCents, consentVersion: t.consentVersion || inl.consentVersion, surface: 'web'
        }, { timeoutMs: 60000 }).then(function (r) {
          var d = r.data || {};
          if (r.status === 409 && (d.code || d.error) === 'not_eligible') {
            refresh();
            return { ok: false, result: 'error', code: 'not_eligible', message: 'Renew with checkout instead — you can choose your payment method there.',
              link: { text: 'Renew with checkout', onClick: function () { var b = document.querySelector('.cb-dialog .cb-x'); if (b) b.click(); r3({ plan: id, provider: 'stripe', intent: 'renew', entry: 'account' }); } } };
          }
          return outcome('renew_inline', r, { texts: t, reload: function () {
            return refresh().then(function () {
              var n = acts().renew && acts().renew.inline; if (!n || !n[id]) return null;
              cur = n[id]; var x = textsOf(n[id], { consentVersion: n.consentVersion }); x.amountCents = n[id].amountCents; return x;
            });
          } });
        });
      }
    }).then(function (res) {
      after('renew_inline', res.ok, res.ok ? 'Welcome back — your ' + PLAN_NAMES[id] + ' plan is active. We’ve emailed your receipt to ' + email() + '.' : null, res.result);
    });
    return true;
  }

  /* R38 — pay the overdue amount of a KEPT plan and restart it (D13.2; D15.1 first_charge_unpaid). */
  function openPayOverdue() {
    var po = acts().payOverdue;
    if (!po || !po.available) return false;
    track('pay_overdue');
    var cur = po;
    UI.confirm({
      action: 'pay_overdue',
      title: 'Pay the overdue amount now?',
      texts: textsOf(po),
      secondaryLabel: null,
      extra: pmExtra('pay-overdue'),
      run: function (t) {
        return UI.api('POST', '/api/billing/pay-overdue', {
          confirm: true, expectedAmountCents: cur.amountCents, consentVersion: t.consentVersion || po.consentVersion, surface: 'web'
        }, { timeoutMs: 60000 }).then(function (r) {
          return outcome('pay_overdue', r, { texts: t, reload: function () {
            return refresh().then(function () {
              var n = acts().payOverdue; if (!n || !n.available) return null;
              cur = n; var x = textsOf(n); x.amountCents = n.amountCents; return x;
            });
          } });
        });
      }
    }).then(function (res) {
      var name = planName((res.result && res.result.planID) || planID());
      after('pay_overdue', res.ok, res.ok ? 'Your ' + name + ' plan is active again. We’ve emailed your receipt to ' + email() + '.' : null, res.result);
    });
    return true;
  }

  /* R16 — [Keep my plan]: one click, the sentence beside the button. No celebration (not a D12.13 moment). */
  function doResume(btn) {
    var rv = acts().resume;
    if (!rv || !rv.available) return;
    track('resume');
    UI.busy(btn, 'Working…');
    UI.api('POST', '/api/billing/resume', { surface: 'web', consentVersion: rv.consentVersion }, { timeoutMs: 30000 }).then(function (r) {
      var d = r.data || {};
      var code = d.code || d.error || '';
      if (r.ok && d.ok) {
        track('resume', 'ok');
        clearCache();
        UI.idle(btn);
        if (!d.alreadyActive) result('ok', 'Your plan will continue. We’ve emailed a confirmation to ' + email() + '.');
        refresh();
        return;
      }
      UI.idle(btn);
      if (r.status === 401) { bounce(); return; }
      if (r.status === 409 && code === 'disclosure_changed' && d.resume) {
        S.actions.resume = d.resume;
        renderResume();
        track('resume', 'disclosure_changed', code);
        result('warn', d.message || MSG.disclosure);
        return;
      }
      if (r.status === 409 && code === 'period_ended') {
        track('resume', 'error', code);
        result('warn', d.message || 'This plan has already ended. You can start a new one from your account page.');
        refresh();
        return;
      }
      track('resume', 'error', code || undefined);
      result('error', d.message || (r.network ? MSG.network : MSG.provider));
    });
  }

  /* R6 — the Interview Stripe portal (its cancellation is OFF, O1). flow payment_method_update + returnAction brings the
     person back to the same action with the new default method ("Use another card or Link", D13.8). */
  function portal(body, btn, action) {
    track(action);
    if (btn) UI.busy(btn, 'Opening…');
    var errBox = $('ac-pm-error');
    if (errBox) errBox.textContent = '';
    return UI.api('POST', '/api/portal', body, { timeoutMs: 20000 }).then(function (r) {
      var d = r.data || {};
      if (r.ok && d.url) { location.assign(d.url); return true; }
      if (btn) UI.idle(btn);
      if (r.status === 401) { bounce(); return false; }
      track(action, 'error', d.code || d.error || undefined);
      var msg = d.message || (r.network ? MSG.network : MSG.portal);
      if (errBox && btn && errBox.closest('#update-payment') && btn.closest('#update-payment')) errBox.textContent = msg;
      else result('error', msg);
      return false;
    });
  }
  function useAnotherMethod(returnAction) {
    return portal({ returnTo: 'account', flow: 'payment_method_update', returnAction: returnAction }, null, 'use_another_method');
  }

  /* =====================================================================================================
     R18 — set the first password (accounts created at checkout)
     ===================================================================================================== */
  $('ac-pw-form').addEventListener('submit', function (e) {
    e.preventDefault();
    var input = $('ac-pw-new'), save = $('ac-pw-save'), msg = $('ac-pw-msg');
    fieldError('ac-pw-new', '');
    msg.hidden = true;
    var pw = input.value;
    if (pw.length < 8) { fieldError('ac-pw-new', 'Please choose a longer password.'); return; }
    track('set_password');
    UI.busy(save, 'Saving…');
    UI.api('POST', '/api/auth/password', { password: pw }, { timeoutMs: 20000 }).then(function (r) {
      var d = r.data || {};
      var code = d.code || d.error || '';
      UI.idle(save);
      if (r.ok && d.ok !== false) {
        input.value = '';
        track('set_password', 'ok');
        if (d.user) adopt({ user: d.user });
        UI.notice(msg, 'ok', 'Password saved. Use it with ' + email() + ' to sign in on your Mac.');
        if (S && S.account) S.account.needsPassword = false;
        clearCache();
        setTimeout(function () { $('set-password').hidden = true; }, 6000);
        return;
      }
      if (r.status === 401) { bounce(); return; }
      track('set_password', 'error', code || undefined);
      if (r.status === 403 || code === 'reauth_required') {
        A.requestReset(email());
        UI.notice(msg, 'info', 'For your security, we’ve emailed you a link to set your password.');
        return;
      }
      if (code === 'weak_password') { fieldError('ac-pw-new', 'Please choose a longer password.'); return; }
      UI.notice(msg, 'error', d.message || (r.network ? 'We could not reach our servers. Check your connection and try again.' : 'We could not save that password. Please try again.'));
    });
  });

  /* =====================================================================================================
     [Cancel subscription] — R20 records the intent AT the click, then the flow continues on its own page (D12.1).
     ===================================================================================================== */
  var cancelBtn = $('ac-cancel');
  cancelBtn.addEventListener('click', function () {
    if (!fresh || cancelBtn.disabled) return;
    var msgBox = $('ac-cancel-msg');
    msgBox.hidden = true;
    track('cancel');
    UI.busy(cancelBtn, 'Opening…');
    var body = {
      clientIntentID: UI.uuid(), surface: 'web', entry: 'web_account', clickedAtMillis: Date.now(),
      locale: (navigator.language || '').slice(0, 35) || undefined
    };
    var build = document.documentElement.getAttribute('data-build');
    if (build) body.siteBuild = build.slice(0, 40);
    function send(retry) {
      return UI.api('POST', '/api/cancel/intents', body, { timeoutMs: 8000 }).then(function (r) {
        if (r.network && !retry) return send(true);   // the SAME clientIntentID: the server replays it
        return r;
      });
    }
    send(false).then(function (r) {
      var d = r.data || {};
      if (r.ok && d.intentID) {
        try {
          sessionStorage.setItem('clozo_cancel_v1', JSON.stringify({
            intentID: d.intentID, email: email(), hasPassword: !(S && S.account && S.account.needsPassword),
            sub: d.subscription || null, voice: d.voice || null, nothingToCancel: d.nothingToCancel || null,
            reasonRequired: d.reasonRequired !== false, offerStep: d.offerStep !== false, at: Date.now()
          }));
        } catch (_) {}
        location.assign('/cancel.html?i=' + encodeURIComponent(d.intentID) + (d.intentHint ? '#h=' + encodeURIComponent(d.intentHint) : ''));
        return;
      }
      UI.idle(cancelBtn);
      if (r.status === 401) { bounce(); return; }
      var code = d.code || d.error || '';
      if (r.status === 429) {
        var mins = Math.max(1, Math.ceil((d.retryAfterSeconds || 3600) / 60));
        UI.notice(msgBox, 'warn', d.message || 'You’ve started cancelling several times in the last hour. Please try again in ' + mins + ' minutes.');
      } else if (r.network) {
        UI.notice(msgBox, 'error', 'We couldn’t reach our servers. Nothing has changed. Try again.');
      } else {
        UI.notice(msgBox, 'error', d.message || 'We couldn’t open the cancellation page just now. Nothing has changed. Try again.');
      }
      track('cancel', 'error', code || undefined);
    });
  });

  /* =====================================================================================================
     Hash actions (R19 next, E-mail action links, R6 returnAction, checkout.js routes) — each only when R12 says the
     action is available; cleared after use. There is no cancel hash.
     ===================================================================================================== */
  function focusSection(id, inner) {
    var t = $(id);
    if (!t || t.hidden) t = $('plan');
    try { t.scrollIntoView({ behavior: UI.reducedMotion() ? 'auto' : 'smooth', block: 'start' }); } catch (_) { t.scrollIntoView(); }
    var f = inner ? t.querySelector(inner) : null;
    try { (f || t).focus({ preventScroll: true }); } catch (_) {}
  }
  /* The list loads after the first summary (its own GET): focus it once it has answered, else `fallback`. */
  function focusPaymentMethods(fallback) {
    var ready = pmWidget && pmWidget.ready ? pmWidget.ready : Promise.resolve();
    ready.then(function () {
      if ($('payment-methods') && !$('payment-methods').hidden) focusSection('payment-methods', '#ac-pm-add');
      else focusSection(fallback, fallback === 'update-payment' ? 'button' : undefined);
    });
  }
  function clearHash() {
    if (!location.hash) return;
    try { history.replaceState(history.state, '', location.pathname + location.search); } catch (_) {}
  }
  function runHash(h) {
    var a = acts();
    clearHash();
    switch (h) {
      case 'start-plan':
        if (!openStartPlan(false)) focusSection('plan');
        break;
      case 'switch-yearly':
        if (!openSwitch()) focusSection('plan');
        break;
      case 'resume':
        if (a.resume && a.resume.available) focusSection('resume', 'button');
        else focusSection('plan');
        break;
      case 'pay-overdue':
        if (!openPayOverdue()) focusSection(S && S.payment ? 'pay-overdue' : 'plan');
        break;
      case 'update-payment':
        // E8's link (a renewal failed): pay it now when it is overdue, else the payment-method list (R41).
        if (S && S.payment) focusSection('pay-overdue', 'button');
        else focusPaymentMethods('update-payment');
        break;
      case 'payment-methods':
        focusPaymentMethods('plan');
        break;
      case 'start-trial':
        if (a.startTrial && a.startTrial.available) startTrial('monthly', 'email', null);
        else if (openPayOverdue()) { /* opened */ }
        else if (a.renew && a.renew.available) focusSection('choose-plan', 'button');
        else focusSection('plan');
        break;
      case 'choose-plan':
        focusSection('choose-plan', 'button');
        break;
      case 'set-password':
        focusSection('set-password', '#ac-pw-new');
        break;
      case 'add-purchase': {   // FS1 #26: the activation email's button and the success page's existing variant land here
        var det = $('add-purchase'); if (det) det.open = true;
        focusSection('get-app', '#ac-activate-code');
        break;
      }
      case 'email':
        focusSection('email');
        break;
      case 'book':
        if ($('book') && !$('book').hidden) focusSection('book');
        else focusSection('plan');
        break;
      case 'renew':
        focusSection('choose-plan', 'button');
        break;
      default:
        if (/^[a-z][a-z0-9-]{0,39}$/.test(h) && $(h) && !$(h).hidden) focusSection(h);
    }
  }
  function currentHash() {
    var h = (location.hash || '').replace(/^#/, '');
    return /^[a-z][a-z0-9-]{0,39}$/.test(h) ? h : '';
  }
  function startupHash() {
    reveal();   // normally done already by the first paint; takes the ?pm=updated line if not
    var h = currentHash();
    if (pmUpdated) {
      // The portal's change reaches us by webhook; read the summary again before naming the new method.
      setTimeout(function () { refresh().then(function () { if (h) runHash(h); }); }, 2000);
      return;
    }
    if (h) runHash(h);
  }
  window.addEventListener('hashchange', function () {
    var h = currentHash();
    if (!h || !fresh) return;
    refresh().then(function () { runHash(h); });
  });

  /* Coming back from a hosted invoice page or the portal in another tab: read the summary again. */
  var lastVisibleRefresh = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible' || UI.isDialogOpen()) return;
    if (Date.now() - lastVisibleRefresh < 5000) return;
    lastVisibleRefresh = Date.now();
    refresh();
    // R41: a method added or made primary in the Mac app shows when this tab comes back (one GET, same throttle).
    if (pmWidget) pmWidget.reload();
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.cb-plan .is-loading, .cb-choose .is-loading, #ac-cancel.is-loading').forEach(function (b) { UI.idle(b); });
    refresh();
  });

  /* checkout.js → 409 use_in_place_action: open the dialog here instead of navigating. */
  UI.setActionHandler(function (action) {
    if (!S || !fresh) return false;
    return openInPlace(action) === true;
  });

  /* =====================================================================================================
     Start: paint the last summary at once (actions disabled), then the server's answer.
     ===================================================================================================== */
  var cached = readCache();
  if (cached) { S = cached; fresh = false; render(); }
  load(true).then(apply);
})();
